import * as React from 'react';
;
/**
 * Represents a React Context which provides you with the option to configure the KendoReact components icons.
 */
export var IconsContext = React.createContext({ type: 'font' });
IconsContext.displayName = 'KendoReactIconsContext';
